<nav>
  <h1>Débora e João Pedro</h1>
  <div class="line"></div>
  <svg (click)="toggleMenu()" viewBox="0 0 100 80" width="30" height="20">
    <rect width="100" height="15"></rect>
    <rect y="30" width="100" height="15"></rect>
    <rect y="60" width="100" height="15"></rect>
  </svg>
  <ul [ngClass]="{'show': showMenu}">
    <li (click)="navigateTo('inicio')">Inicio</li>
    <li (click)="navigateTo('historia')">História</li>
    <li (click)="navigateTo('countdown')">Quando?</li>
    <li (click)="navigateTo('rsvp')">RSVP</li>
    <li (click)="navigateTo('presentes')">Presentes</li>
  </ul>
  <div class="line"></div>
  <p [ngClass]="{'show': showMenu}">Feito por Jéssica e João<span>&copy;</span></p>
</nav>
